import { createContext } from 'react';
import type { LocaleType } from './Locale';

interface ILocaleContext {
  locale: LocaleType;
  setLocale?: (locale: LocaleType) => void;
}

export const LocaleContext = createContext<ILocaleContext>({
  locale: 'is',
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setLocale: () => {},
});
